import * as yup from 'yup';
import { orgId, FieldValidation, linkRegex } from 'utils';
import { useRef } from 'react';

export default ({ userStatus, isFedRAMPCustomer }) => {
  const cacheTest = (asyncValidate) => {
    let _valid = false;
    let _value = '';

    return async (value) => {
      if (value !== _value) {
        const response = await asyncValidate(value);
        _value = value;
        _valid = response;
        return response;
      }
      return _valid;
    };
  };
  const usernameValidation = new FieldValidation();
  const checkUsernameUnique = async (value) => {
    if (!value || value.length < 4 || !/^[a-zA-Z\d_.@-]*$/.test(value)) return true;
    return usernameValidation.valid(value,
      `/${orgId}/signup/checkUsername?username=${value}`);
  };
  const emailUniqueTest = useRef(cacheTest(checkUsernameUnique));

  let validationRule;
  if (isFedRAMPCustomer) {
    validationRule = 'fedramp';
  } else {
    validationRule = userStatus;
  }
  const passwordValidateRoles = {
    public: {
      length: 8,
      pattern: /(^(?=.*?[A-Za-z])(?=.*?[\d])[a-zA-Z\d!@#$%^&*()]*$)/,
    },
    private: {
      length: 8,
      pattern: /(^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[\d])[a-zA-Z\d!@#$%^&*()]*$)|(^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[!@#$%^&*()])[a-zA-Z\d!@#$%^&*()]*$)|(^(?=.*?[A-Z])(?=.*?[\d])(?=.*?[!@#$%^&*()])[a-zA-Z\d!@#$%^&*()]*$)|(^(?=.*?[a-z])(?=.*?[\d])(?=.*?[!@#$%^&*()])[a-zA-Z\d!@#$%^&*()]*$)/,
    },
    fedramp: {
      length: 12,
      pattern: /(^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[\d])(?=.*?[!@#$%^&*()])[a-zA-Z\d!@#$%^&*()]*$)/,
    },
  };
  return {
    firstName: yup
      .string()
      .trim()
      .required('jquery.validation.field.required, ssp.register.firstname')
      .test('firstName', 'ssp.field.firstname.invalid', (value) => !linkRegex.test(value)),
    lastName: yup
      .string()
      .trim()
      .required('jquery.validation.field.required, ssp.register.lastname')
      .test('lastName', 'ssp.field.lastname.invalid', (value) => !linkRegex.test(value)),
    username: yup
      .string()
      .required('login.username.required')
      .min(4, 'jquery.validation.minlength')
      .matches(/^[a-zA-Z\d_.@-]*$/, 'ssp.login.username.invalid')
      .test('username', 'ssp.login.username.exist', emailUniqueTest.current),
    password: yup
      .string()
      .trim()
      .required('login.password.required')
      .min(
        passwordValidateRoles[validationRule].length,
        `jquery.validation.minlength,
        ${passwordValidateRoles[validationRule].length}`
      )
      .matches(passwordValidateRoles[validationRule].pattern, 'ssp.password.valid.invalid'),
    securityAnswer: yup
      .string()
      .trim()
      .required('jquery.validation.field.required, ssp.register.answer')
      .min(2, 'jquery.validation.minlength, 2'),
  };
};
